import { size } from '../../size.mjs';

var border = {
  'border-radius-0': {
    value: size[0]
  },
  'border-radius-050': {
    value: size['050']
  },
  'border-radius-100': {
    value: size[100]
  },
  'border-radius-150': {
    value: size[150]
  },
  'border-radius-200': {
    value: size[200]
  },
  'border-radius-300': {
    value: size[300]
  },
  'border-radius-400': {
    value: size[400]
  },
  'border-radius-500': {
    value: size[500]
  },
  'border-radius-750': {
    value: size[750]
  },
  'border-radius-full': {
    value: '9999px'
  },
  'border-width-0': {
    value: size['0']
  },
  'border-width-0165': {
    value: size['0165']
  },
  'border-width-025': {
    value: size['025']
  },
  'border-width-050': {
    value: size['050']
  },
  'border-width-100': {
    value: size[100]
  }
};

export { border };
